const ThemeColors = {
  primary: {
    light: '#727CF5',
    main: '#727CF5',
    dark: '#4e5bf2',
    contrastText: '#fff'
  },
  secondary: {
    light: '#6c757d',
    main: '#6c757d',
    dark: '#5a6268',
    contrastText: '#fff'
  },
  success: {
    light: '#0acf97',
    main: '#0acf97',
    dark: '#089e74',
    contrastText: '#fff'
  },
  error: {
    light: '#fa5c7c',
    main: '#fa5c7c',
    dark: '#f9375e',
    contrastText: '#fff'
  }
}

export default ThemeColors;

export const styles = () => {
  const style = {
    "--panda-gray-color": '#999',
    "--panda-red-color": '#a00',
  };
  for (let key in ThemeColors) {
    for (let field in ThemeColors[key]) {
      style[`--panda-${key}-${field}`] = ThemeColors[key][field]
    }
  }
  return style
}